import { t } from '@lingui/core/macro';
import { NoddiSkeleton } from 'noddi-ui-web';

/**
 * Loading state mirroring the final two-card layout at its final heights, so the
 * page does not collapse and re-expand when the garages query resolves. The card shells are a
 * skeleton wash, not white, so the placeholder never passes for a real (empty) card.
 */
export function BookingChoiceSkeleton() {
  return (
    <div role='status' className='flex flex-col gap-3 md:grid md:grid-cols-2 md:items-stretch md:gap-6'>
      <span className='sr-only'>{t`Loading`}</span>
      <div className='flex h-full flex-col overflow-hidden rounded-[22px] bg-skeleton/40 md:rounded-3xl'>
        <NoddiSkeleton className='h-[190px] shrink-0 rounded-none md:h-60' />
        <div className='flex flex-1 flex-col gap-5 p-5 pb-6 md:gap-6 md:p-6'>
          <NoddiSkeleton className='h-7 w-3/4' />
          <div className='flex flex-col gap-3'>
            <NoddiSkeleton className='h-4 w-2/3' />
            <NoddiSkeleton className='h-4 w-1/2' />
          </div>
          <NoddiSkeleton className='mt-auto h-14 w-full rounded-xl' />
        </div>
      </div>

      <div className='flex h-full flex-col overflow-hidden rounded-[22px] bg-skeleton/40 md:rounded-3xl'>
        <NoddiSkeleton className='h-[150px] shrink-0 rounded-none md:h-60' />
        <div className='flex flex-1 flex-col gap-4 p-5 pb-6 md:gap-5 md:p-6'>
          <div className='flex flex-col gap-1.5'>
            <NoddiSkeleton className='h-3 w-1/3' />
            <NoddiSkeleton className='h-6 w-2/3' />
          </div>
          <div className='flex flex-col gap-2'>
            <NoddiSkeleton className='h-4 w-1/2' />
            <NoddiSkeleton className='h-4 w-2/5' />
          </div>
          <div className='mt-auto flex flex-col gap-2.5'>
            <NoddiSkeleton className='h-[54px] w-full rounded-xl' />
            <NoddiSkeleton className='h-[54px] w-full rounded-xl' />
          </div>
        </div>
      </div>
    </div>
  );
}
